import { useTheme } from "@mui/material/styles";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	const { palette } = useTheme();

	return (
		<CssColumnGrid columns={4}>
			<Text semiBold text="default" />
			<Text semiBold text="error (small)" />
			<Text semiBold text="primary" />
			<Text semiBold text="custom (large)" />
			<AttachFileIcon />
			<AttachFileIcon color="error" fontSize="small" />
			<AttachFileIcon color="primary" />
			<AttachFileIcon fontSize="large" style={{ color: palette.LinkDefault }} />
		</CssColumnGrid>
	);
};